import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataUrl } from './InputDataUrl';
import { InputDataOutputsArraySchema } from '../schema/InputDataSchema';

export interface InputDataOutputsParams {
  descriptionId: string;
  valueDate: string;
}

const getInputDataOutputs = (params?: InputDataOutputsParams) =>
  apiClient
    .get(expand(InputDataUrl.INPUT_DATA_OUTPUTS, params))
    .then((response) => InputDataOutputsArraySchema.parse(response.data));

export const useInputDataOutputsQuery = createApiQueryHook(
  ['inputDataOutputs'],
  getInputDataOutputs
);
